import { Component, Input } from '@angular/core';
import { subDays } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs';
import { DashboardsService } from 'src/app/modules/app/dashboards/dashboards.service';
import { employee, todayReport } from 'src/app/modules/app/_reports/interfaces';

@Component({
  selector: 'app-dashboard-tody-card',
  templateUrl: './dashboard-tody-card.component.html',
  styleUrls: ['./dashboard-tody-card.component.scss'],
})
export class DashboardTodyCardComponent {
  constructor(
    private _dashboardServ: DashboardsService,
    private _toastrServ: ToastrService
  ) {
    this.GetDailyReport();
  }
  private _records: any = {};
  public get records(): any {
    return this._records;
  }
  public set records(v: any) {
    this._records = v;
  }
  private _recordsKeys: string[] = [];
  public get recordsKeys(): string[] {
    return this._recordsKeys;
  }
  public set recordsKeys(v: string[]) {
    this._recordsKeys = v;
  }

  private _dates: { from: string; to: string } = {
    from: subDays(new Date(), 7).toISOString().split('.')[0],
    to: new Date().toISOString().split('.')[0],
  };
  public get dates(): { from: string; to: string } {
    return this._dates;
  }
  public set dates(v: { from: string; to: string }) {
    this._dates = v;
  }

  private _loading!: boolean;
  public get loading(): boolean {
    return this._loading;
  }
  public set loading(v: boolean) {
    this._loading = v;
  }

  GetDailyReport() {
    this.loading = true;
    this._dashboardServ
      .GetDailyReport()
      // .pipe(map((reports) => reports.filter((x: any) => x.timeOut)))
      .subscribe({
        next: (res) => {
          this.records = res;
          setTimeout(() => {
            // console.log(res);
            this.recordsKeys = Object.keys(res);
          }, 1000);

          this.loading = false;
        },
        error: (err) =>
          this._toastrServ.error(
            'Something went wrong while fetching reports...'
          ),
      });
  }
}
